import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface SelfTestStatusRendererProps {
  value: boolean;
}

export default function SelfTestStatusRenderer({
  value,
}: SelfTestStatusRendererProps): ReactElement {
  const { t } = useTranslation();

  const label = value ? t('ActiveFault') : t('Failed');
  const status = value ? BadgeStatus.Danger : BadgeStatus.Information;

  return <StatusCell label={label} status={status} />;
}
